const wrapper = path => props => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="1.5rem" width="1.5rem" {...props}>
        {path}
    </svg>
)

export const IconAdd = wrapper(
    <path d="M10.675 19.35V13.3h-6.05v-2.65h6.05V4.6h2.65v6.05h6.05v2.65h-6.05v6.05Z" />
)

export const IconExpandMore = wrapper(
    <path d="m12 15.875-6.5-6.5L7.375 7.5 12 12.125 16.625 7.5 18.5 9.375Z" />
)

export const IconUploadFile = wrapper(
    <path d="M10.65 19.75h2.6V15.5l1.475 1.475 1.75-1.75L11.95 10.7l-4.525 4.525 1.75 1.75L10.65 15.5ZM5.9 22.8q-1.1 0-1.875-.775-.775-.775-.775-1.875V3.85q0-1.1.775-1.875Q4.8 1.2 5.9 1.2h7.8l7.05 7.025V20.15q0 1.1-.775 1.875-.775.775-1.875.775Zm6.5-13.25v-5.7H5.9v16.3h12.2V9.55Zm-6.5-5.7v5.7-5.7 16.3-16.3Z" />
)

export const IconCheck = wrapper(
    <path d="m9.55 18.55-6.3-6.3 1.875-1.875L9.55 14.8l9.375-9.375L20.8 7.3Z" />
)

export const IconArrowBack = wrapper(
    <path d="m12 20.65-8.625-8.625L12 3.4l1.9 1.9-5.4 5.4h12.125v2.65H8.5l5.4 5.4Z" />
)

export const IconArrowForward = wrapper(
    <path d="m12 20.65-1.9-1.9 5.4-5.4H3.375V10.7H15.5l-5.4-5.4L12 3.4l8.625 8.625Z" />
)

export const IconErrorStatusOrange = wrapper(
    <>
        <circle fill="var(--color-orange-attention)" cx="12" cy="12" r="10" />
        <path d="M12 17q.425 0 .713-.288Q13 16.425 13 16t-.287-.713Q12.425 15 12 15t-.712.287Q11 15.575 11 16t.288.712Q11.575 17 12 17Zm-1-4h2V7h-2Zm1 9q-2.075 0-3.9-.788-1.825-.787-3.175-2.137-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175 1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138 1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4 8.65 4 6.325 6.325 4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Zm0-8Z" />
    </>
)

export const IconDownload = wrapper(
    <path d="M5.9 20.775q-1.1 0-1.875-.775-.775-.775-.775-1.875v-3.05H5.9v3.05h12.2v-3.05h2.65v3.05q0 1.1-.775 1.875-.775.775-1.875.775Zm6.125-4.6-6-6L7.9 8.3l2.8 2.8V3.075h2.65V11.1l2.8-2.8 1.875 1.875Z" />
)

export const IconShowChart = wrapper(
    <path d="m3.35 19.05-2-2L9.45 9l4.05 4.05 7.35-8.15 1.85 1.85-9.2 10.3L9.45 13Z" />
)

export const IconCancel = wrapper(
    <path d="M6.3,19.6l-1.8-1.9l5.7-5.7L4.5,6.2l1.8-1.9l5.7,5.8l5.7-5.8l1.9,1.9L13.9,12l5.7,5.7l-1.9,1.9L12,13.9L6.3,19.6z" />
)

export const IconLoaderSpinning = wrapper(
    <path className="loader-spinning" d="M3.2,17.5c-0.5-0.8-0.9-1.7-1.2-2.6S1.7,13,1.7,12c0-1.4,0.3-2.8,0.8-4C3,6.7,3.8,5.6,4.7,4.7S6.7,3,8,2.5c1.3-0.5,2.6-0.8,4-0.8c1.4,0,2.8,0.3,4,0.8c1.3,0.5,2.3,1.3,3.3,2.2c0.9,0.9,1.7,2,2.2,3.3c0.5,1.3,0.8,2.6,0.8,4c0,1-0.1,1.9-0.4,2.8c-0.3,0.9-0.7,1.8-1.2,2.6l-1.9-1.9c0.3-0.6,0.5-1.1,0.6-1.7c0.1-0.6,0.2-1.2,0.2-1.8c0-2.1-0.7-3.9-2.2-5.4S14.1,4.3,12,4.3S8.1,5.1,6.6,6.6S4.3,9.9,4.3,12c0,0.6,0.1,1.2,0.2,1.8c0.1,0.6,0.4,1.2,0.6,1.7L3.2,17.5z" />
)
